// 点呼表 CSV 用。Excel 等が「1-2」を日付（1月2日）に自動変換しないよう ="…" 形式で文字列として出す。
export const excelText = (v) => {
  const s = String(v ?? "");
  return s ? `="${s.replace(/"/g, '""')}"` : "";
};

const esc = (v) => {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const toCsv = (matrix) => matrix.map((r) => r.map(esc).join(",")).join("\r\n");
